import styled from 'styled-components';

export const Avatar = styled.img`
  width: 130px;
  height: 130px;
`;
